
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Link from "@/components/Link.vue";
import P5 from "p5";
import BookMenu from "@/components/BookMenu.vue";
import ColorScaleCompService from '@/services/ColorScaleComp.service';
import ColorScalesHeader from "@/components/ColorScalesHeader.vue";
import BackButton from "@/components/BackButton.vue";

const namespace = "BookModule";

@Component({
  components: {
    Link,
    BookMenu,
    ColorScalesHeader,
    BackButton
  },
})

export default class ArticleInstrumentIntro extends Vue{
  @Mutation('setNOctaves', {namespace}) private setNOctaves!: (value:number) => any;
  @Mutation('setBaseHue', {namespace}) private setBaseHue!: (value:number) => any;
  @State('nOctaves', { namespace }) private nOctaves!:  number;
  @State('baseHue', { namespace }) private baseHue!:  number;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }

  private getColor(h:number, l:number){
    return ColorScaleCompService.HLtoHEX(h,l);
  }

  private handleOctavesSlider(event:any){
    this.setNOctaves(parseInt(event.target.value));
  }

  private handleHueSlider(event:any){
    this.setBaseHue(parseInt(event.target.value));
  }
};
